module.exports = __webpack_public_path__ + "img/tuition_layout6.ee03e460.png";